import React, { useEffect } from 'react';
import { useParams } from 'react-router';

import styled from '@emotion/styled';

import TrendDownIcon from '../../../components/Icons/TrendDownIcon';
import TrendUpIcon from '../../../components/Icons/TrendUpIcon';
import useDistributionInsight from '../../../hooks/dashboard/driver-list/useDistributionInsight';

interface StatsCardBoxProps {
  header: string;
  stats: number;
  footer: string;
  trend?: boolean;
}

const StatsCardBox: React.FC<StatsCardBoxProps> = ({
  header,
  stats,
  footer,
  trend,
}) => {
  return (
    <ContainerBox>
      <Header>{header}</Header>
      <StatsArea className={trend ? (stats >= 0 ? 'green' : 'red') : ''}>
        {trend ? stats >= 0 ? <TrendUpIcon /> : <TrendDownIcon /> : ''} {stats}%
      </StatsArea>
      <Footer>{footer}</Footer>
    </ContainerBox>
  );
};

interface StatsCardProps {
  data: any;
}

const StatsCard: React.FC<StatsCardProps> = ({ data }) => {
  const { driverId } = useParams<{ driverId: string }>();
  const { getDistributionDataInsight, distributionInsightData } =
    useDistributionInsight();

  useEffect(() => {
    if (driverId) {
      getDistributionDataInsight(driverId);
    }
    // eslint-disable-next-line
  }, [driverId]);

  const statsCardData = [
    {
      header: 'LogiScore',
      stats: Number(distributionInsightData?.logiScore ?? 0),
      footer: 'Current Performance',
    },
    {
      header: 'Baseline',
      stats: Number(distributionInsightData?.baseline ?? 0),
      footer: 'Performance Standard',
    },
    {
      header: 'Difference',
      stats: Number(distributionInsightData?.difference ?? 0),
      footer: `${Number(distributionInsightData?.difference ?? 0) > 0 ? 'Exceeding Baseline Performance' : ''}`,
      trend: true,
    },
  ];

  return (
    <Container>
      {statsCardData.map((data, index) => (
        <StatsCardBox key={index} {...data} stats={Number(data.stats)} />
      ))}
    </Container>
  );
};

export default StatsCard;

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 28px;
`;

const ContainerBox = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  border-radius: 8px;
  padding: 24px;
  border-radius: 8px;
  gap: 12px;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.neutralGray};
`;

const StatsArea = styled.div`
  line-height: 38px;
  font-size: 38px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.logirateBlack};
  display: flex;
  align-items: center;
  gap: 16px;
  /* justify-content: center; */

  &.red {
    color: #ff0500;
  }

  &.green {
    color: #22b231;
  }
`;

const Footer = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.mediumGrayText};
`;
